'use strict';

// 核心
import React from 'react';
import {EventEmitter} from 'events';
import classnames from 'classnames';
import {extend} from 'jquery';

//
import Component from '../core/component';
import Enhance from '../core/enhance';


// 组件
import Icon from '../common/icon';
import Handler from './handler';
import Link from './link';
import Switch from './switch';

// 工具
import {isEqual} from '../libs/tools';


let {pushState} = Handler;
let cache = {};

/**
 *
 */
class Page extends Component {
    state = {};

    constructor(props) {
        super(props);
        extend(this.state, props, true);
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        // this.refs.page.focus();
    }

    /**
     *shouldComponentUpdate(object nextProps, object nextState): boolean
     * 当组件做出是否要更新DOM的决定的时候被调用。
     * 实现该函数，优化this.props和nextProps，以及this.state和nextState的比较，
     * 如果不需要React更新DOM，则返回false。
     */
    shouldComponentUpdate(nextProps, nextState) {
        // console.log(this._reactInternalInstance);
        return true;
    }


    componentWillLeave(callback) {
        console.log('componentWillLeave');
    }

    render() {
        var Elem = this.state.elem ? this.state.elem : 'div';

        return (
            <Elem
                ref="page"
                className={classnames(['page page-current', this.props.className])}
            >
                {this.props.children}
            </Elem>
        );
    }
}

/**
 *
 */
class Header extends Component {
    state = {};

    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }


    render() {
        return (
            <header className="bar bar-nav">
                {this._handlerLeft()}
                {this._handlerRight()}
                <h1 className="title">{this.props.title}</h1>
            </header>
        );
    }

    _handlerLeft() {
        return this.props.left && this.props.left.map((item, key)=> {
                return (
                    <Link key={key}
                          className={classnames(`button button-link button-nav pull-left`)}
                          href={item.href}
                          onClick={item.onClick}
                    >
                        <Icon icon={item.icon}></Icon>{item.title || ''}
                    </Link>
                );
            });
    }

    _handlerRight() {
        return this.props.right && this.props.right.map((item, key)=> {
                return (
                    <Link
                        key={key}
                        className={classnames(`button button-link button-nav pull-right`)}
                        href={item.href}
                        onClick={item.onClick}
                    >
                        <Icon icon={item.icon}></Icon>{item.title || ''}
                    </Link>
                )
            });
    }


}

/**
 *
 */
class Content extends Component {
    state = {
        scrollTop: 0,
        className: "native-scroll",
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.uuid && (this.refs['content'].scrollTop = cache[this.props.uuid]);
    }

    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
    }

    /**
     * componentDidUpdate(object prevProps, object prevState)在更新发生之后调用。
     */
    componentDidUpdate(prevProps, prevState) {
    }


    render() {
        // console.log('page.content render');
        return (
            <div ref='content' className={classnames("content",this.props.className)} onScroll={this._handlerScroll}>
                {this.props.children}
            </div>
        );
    }


    _handlerScroll = (e)=> {
        if (this.props.uuid)
            cache[this.props.uuid] = this.refs['content'].scrollTop;
    }
}

class ToolsButton extends Component {
    render() {
        return (
            <Link
                className={classnames(['tab-item external', {active: this.props.active}])}
                onClick={this.props.onClick}
                href={this.props.href}
            >
                {this.props.icon ? <Icon className="icon" icon={this.props.icon[this.props.active ? 1 : 0]}></Icon> : null}
                {this.props.title ? <span className="tab-label">{this.props.title}</span> : null}
                {this.props.badge ? <span className="badge">{this.props.badge}</span> : null}
            </Link>
        )
    }
}
/**
 *
 */
class Tools extends Component {
    state = {
        selected: 0
    };

    constructor(props) {
        super(props);
        // plus.nativeUI.showMenu(
        //     {title: "比价", badge: true},
        //     [{title: "淘宝网"}, {title: "京东"}, {title: "唯品会", checked: true}],
        //     function (e) {
        //         console.log("点击了 " + e.target.title + " 菜单项");
        //     });
    }


    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
    }


    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {

    }


    render() {
        return (
            <nav className="bar bar-tab">
                <Switch {...this.props}>
                    {this.props.children}
                </Switch>
            </nav>
        );
    }


    _handlerCreateNavItem = ()=> {

        var data = Handler.queryData(this.props.search);

        if (this.props.default && !data[this.props.search]) {
            data[this.props.search] = this.props.default
        }
        var index = data[this.props.search];

        if (data[this.props.search] && this.props.items.map) {
            return this.props.items.map((item, key)=> {
                return (
                    <Link
                        key={key}
                        className={classnames(['tab-item external', {active: key == index}])}
                        onClick={item.onClick}
                        href={item.href}
                    >
                        {item.icon ? <Icon className="icon" icon={item.icon.map ? item.icon[key == index ? 1 : 0] : item.icon}></Icon> : null}
                        <span className="tab-label">{item.title}</span>
                        {item.badge ? <span className="badge">{item.badge}</span> : null}
                    </Link>
                );
            });
        }
        return null;
    }
}

/**
 *
 */
class SubHeader extends Component {

    render() {
        return (
            <div className="bar bar-header-secondary" style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

/**
 *
 */
class Bottom extends Component {

    render() {
        return (
            <div className="bar bar-footer" style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

/**
 *
 */
class SubBottom extends Component {

    render() {
        return (
            <div className="bar bar-footer-secondary" style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}

class Popup extends Component {

}

Page.Popup = Enhance(Popup, {}, 'Popup');
Page.Content = Enhance(Content, {}, 'Content');
Page.Header = Enhance(Header, {}, 'Header');
Page.SubHeader = Enhance(SubHeader, {}, 'SubHeader');
Page.Bottom = Enhance(Bottom, {}, 'Bottom');
Page.SubBottom = Enhance(SubBottom, {}, 'SubBottom');
Page.Tools = Enhance(Tools, {}, 'Tools');
Page.Tools.Button = Enhance(ToolsButton, {}, 'ToolsButton');
export default Enhance(Page, {}, 'Page')
